import axios from 'axios'

const service = axios.create({
  baseURL: process.env.VUE_APP_API
})

service.interceptors.request.use(config => {
  if (
    config.url !== '/oauth/access_token' &&
    new Date().getTime() / 1000 + 60 > localStorage.getItem('expires') &&
    localStorage.getItem('expires') > 0
  ) {
    const api = process.env.VUE_APP_API
    return axios.post(`${api}/oauth/access_token`, null, {
      params: { grant_type: 'refresh_token', refresh_token: localStorage.getItem('refresh_token') },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(res => {
      const now = new Date().getTime() / 1000
      localStorage.setItem('access_token', res.data.access_token)
      localStorage.setItem('expires_in', res.data.expires_in)
      localStorage.setItem('expires', now + res.data.expires_in)
      localStorage.setItem('refresh_token', res.data.refresh_token)
      localStorage.setItem('roles', res.data.roles)
      localStorage.setItem('token_type', res.data.token_type)
      localStorage.setItem('username', res.data.username)
      config.headers.Authorization = `Bearer ${localStorage.getItem('access_token')}`
      return config
    })
  } else {
    if (localStorage.getItem('access_token')) {
      config.headers.Authorization = `Bearer ${localStorage.getItem('access_token')}`
    }
  }
  return config
})

// respone拦截器
service.interceptors.response.use(res => {
  return res
},
error => {
  // console.log('err' +JSON.stringify(error)) // for debug
  // const config = response.config
  if (error.response) {
    console.log(`error.response.status:${error.response.status}`)
    switch (error.response.status) {
      case 401:
        console.log('401')
        if (error.config.url !== 'oauth/access_token') {
          const api = process.env.VUE_APP_API
          return axios.post(`${api}/oauth/access_token`, null, {
            params: { grant_type: 'refresh_token', refresh_token: localStorage.getItem('refresh_token') },
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then(res => {
            const now = new Date().getTime() / 1000
            localStorage.setItem('access_token', res.data.access_token)
            localStorage.setItem('expires_in', res.data.expires_in)
            localStorage.setItem('expires', now + res.data.expires_in)
            localStorage.setItem('refresh_token', res.data.refresh_token)
            localStorage.setItem('roles', res.data.roles)
            localStorage.setItem('token_type', res.data.token_type)
            localStorage.setItem('username', res.data.username)
            error.config.headers['Content-Type'] = 'application/json'
            error.config.headers.Authorization = `Bearer ${localStorage.getItem('access_token')}`
            return service(error.config)
          }).catch(e => {
            // 刷新token失败只能跳转到登录页重新登录
            console.log(`刷新token失败只能跳转到登录页重新登录:${e}`)
            // Utils.Auth.logOut()
            // return Promise.reject(error.response.data);
            throw Promise.reject(error.response.data)
          })
        } else {
          console.log('刷新token失败只能跳转到登录页重新登录2')
          // Utils.Auth.logOut()
          // return Promise.reject(error.response.data);
          throw Promise.reject(error.response.data)
        }
      case 403:
        if (error.response.data.error === 'Forbidden' && error.response.data.message === 'Forbidden') {
          console.log(`error.response.error:${'Forbidden'}`)
          // Message({
          //   message: '此帳戶權限不足!',
          //   type: 'warning'
          // })
        }
        throw Promise.reject(error.response.data)
      case 500:
        // Message({
        //   message: '請洽系統管理員或產品服務人員!',
        //   type: 'error'
        // })
        throw Promise.reject(error.response.data)
      default:
        console.log('default')
        if (error.response.data) {
          // Message({
          //   message: error.response.data.message,
          //   type: 'error'
          // })
        } else {
          // Message({
          //   message: error.message,
          //   type: 'error'
          // })
        }

        // return Promise.reject(error.response.data);
        throw Promise.reject(error.response.data)
    }
    // 返回介面返回的錯誤資訊
  }
}
)

export default service
